import api from '@/api'
import * as TYPES from './mutation-types'

export default {
  [TYPES.FETCH_AGENTS] ({ state }) {
    return api.get('agent').then(({ data }) => {
      state.agents = data.data
      return data
    }, (error) => {
      return error
    })
  },

  [TYPES.FETCH_AGENTCHILDS] ({ state }, user) {
    api.get('childs?role=0&master_id='+user.id).then(({ data }) => {
      console.log("Fetch Agent")
    state.agentchilds[user.id] = data.data;
    state.masteragentchilds = data.data;     
    }, (error) => {
      
    })
    
  },
  [TYPES.FETCH_AGENTCLIENTS] ({ state }, user) {
      
      api.get('childs?role=1&master_id='+user.id).then(({ data }) => {
       // console.log("Fetch Client")
      //  state.agentclients[user.id] = data.data;
      //  console.log(state.agentclients[user.id])
       // state.masteragentclients = data.data;
       // state.agentclients[user.id] = data.data;
        // state.agentclients = data.data;
       // state.masteragentclients = data.data;
       //  debugger;
        state.agentclients = data.data
      }, (error) => {
        
      })
    
  },
  [TYPES.FETCH_AGENTAMOUNTREPORT] ({ state }, user) {
     
      api.get('agent/amountreport?user_id='+user.id).then(({ data }) => {
       // state.agentchilds[user.id] = data.data;
        //state.masteragentchilds = data.data;

        state.agentamountrecord = data.data;
       
      }, (error) => {
        
      })
    
  },

  [TYPES.FETCH_PROFITLOSSREPORT] ({ state }, user) {
     
      api.get('agent/profitloss?user_id='+user.id).then(({ data }) => {

        state.profitlossreport = data.data;
        
       // return state.profitlossreport;
      //  debugger;
      }, (error) => {
        
      })
    
  },


  [TYPES.UPDATE_BALANCE] ({ state }, data ) {
    let idIndex =  _.findIndex(state.tabs, {id: data.agent_id}); 
    state.tabs[idIndex].balance = data.balance
  },

  [TYPES.FETCH_CUREXCHANGE] ({ state }, user) {
     
      api.get('exchangerate').then(({ data }) => {
         
        state.curexchangereport = data.data;
       
       // return state.profitlossreport;
      //  debugger;
      }, (error) => {
        
      })
    
  },

  [TYPES.FETCH_AGENTCREDITREPORTS] ({ state }, user) {
     
      api.get('agent/credit/report').then(({ data }) => {
        //debugger;
        state.agentcreditreport = data.data;
       
       // return state.profitlossreport;
      //  debugger;
      }, (error) => {
        
      })
    
  },

  [TYPES.FETCH_LOGREPORTS] ({ state }, user) {
     
      api.get('operationlog').then(({ data }) => {
       // debugger;
        state.operatorlogreports = data.data;
       
       // return state.profitlossreport;
      //  debugger;
      }, (error) => {
        
      })
    
  },

  [TYPES.FETCH_CLIENTCREDITREPORTS] ({ state }, user) {
     
      api.get('client/credit/report').then(({ data }) => {
       // debugger;
        state.clientcreditreport = data.data;
       
       // return state.profitlossreport;
      //  debugger;
      }, (error) => {
        
      })
    
  },

  [TYPES.FETCH_REBATEREPORTS] ({ state }, user) {
     
      api.get('client/rebate/claim/log').then(({ data }) => {
       // debugger;
        state.claimrebatereports = data.data;
       
       // return state.profitlossreport;
      //  debugger;
      }, (error) => {
        
      })
    
  },

  [TYPES.FETCH_BETRECORDS] ({ state }, report) {
    
    

      let endpoin = '';
      if (report.gametype == 1){
        endpoin = 'bacaratlog';
      } else if (report.gametype == 2){
        endpoin = 'longhulog';
      }
      else if (report.gametype == 3){
        endpoin = 'sicbolog';
      } else if (report.gametype == 4){
        endpoin = 'roulettelog';
      }

      //state.betrecords = [];
if(state.betrecords.length == 0){
    // debugger;
      state.betrecords = [];
      api.get('client/bacaratlog').then(({ data }) => {
          state.betrecordbacarat = data.data;

         _.forEach(state.betrecordbacarat, function(value, key){
             
              state.betrecords.push(value)
          })
      })

       api.get('client/longhulog').then(({ data }) => {
         
          state.betrecordlonghu = data.data;
         _.forEach(state.betrecordlonghu, function(value, key){
             state.betrecords.push(value)
          })
      })

       api.get('client/sicbolog').then(({ data }) => {
         
          state.betrecordsicbo = data.data;
         _.forEach(state.betrecordsicbo, function(value, key){
             state.betrecords.push(value)
          })
      })

      api.get('client/roulettelog').then(({ data }) => {
         
          state.betrecordroulette = data.data;
         _.forEach(state.betrecordroulette, function(value, key){
             state.betrecords.push(value)
          })
      }) 

    }
     
    
  },

  [TYPES.UPDATE_AGENTCHILDS] ({ state }, agent) {
     return api.put('agent', agent).then(({ data }) => {
      
      
      return data
    }, (error) => {
      return error
    })
   
  },

  [TYPES.UNLOCK_USER] ({ state }, agent) {
     return api.post('user/unlock', agent).then(({ data }) => {
      
      return data
    }, (error) => {
      return error
    })
   
  },

  [TYPES.LOCK_USER] ({ state }, agent) {
     return api.post('user/lock', agent).then(({ data }) => {
      
      return data
    }, (error) => {
      return error
    })
   
  },

  [TYPES.ENABLE_USER] ({ state }, agent) {
     return api.post('user/enable', agent).then(({ data }) => {
      
      return data
    }, (error) => {
      return error
    })
   
  },

  [TYPES.DISABLE_USER] ({ state }, agent) {
     return api.post('user/disable', agent).then(({ data }) => {
      
      return data
    }, (error) => {
      return error
    })
   
  },

  [TYPES.CLAIM_REBATE] ({ state }) {
     return api.get('client/rebate/claim').then(({ data }) => {
      
      return data
    }, (error) => {
      return error
    })
   
  },

  [TYPES.CHANGE_PASSWORD] ({ state }, agent) {
     return api.post('user/changepassword', agent).then(({ data }) => {
      
      return data
    }, (error) => {
      return error
    })
   
  },

   [TYPES.LOCKBET_USER] ({ state }, agent) {
     return api.post('user/betlock', agent).then(({ data }) => {
      
      return data
    }, (error) => {
      return error
    })
   
  },

  [TYPES.UNLOCKBET_USER] ({ state }, agent) {
     return api.post('user/betunlock', agent).then(({ data }) => {
      
      return data
    }, (error) => {
      return error
    })
   
  },


  [TYPES.CREATE_AGENTCHILD] ({ state }, agent) {

    return api.post('agent', agent).then(({ data }) => {
      
      
      return data
    }, (error) => {
      return error
    })
  },
  
  [TYPES.CREATE_AGENTCLIENT] ({ state }, agent) {
   return api.post('client', agent).then(({ data }) => {
     
      return data
    }, (error) => {
      return error
    })
  },

   [TYPES.UPDATE_AGENTCLIENT] ({ state }, agent) {
     return api.put('client', agent).then(({ data }) => {
      
      
      return data
    }, (error) => {
      return error
    })
   
  },

  [TYPES.FETCH_AGENTSUBACCOUNTS] ({ state }, user) {
    
      api.get('childs?role=2&master_id='+user.id).then(({ data }) => {
       
        state.agentsubaccounts = data.data
      }, (error) => {
        
      })
    
  },
  [TYPES.CREATE_AGENTSUBACCOUNT] ({ state }, agent) {
    return api.post('subaccount', agent).then(({ data }) => {
       return data
    }, (error) => {
      return error
    })
  },

  [TYPES.UPDATE_AGENTSUBACCOUNT] ({ state }, agent) {
     return api.put('subaccount', agent).then(({ data }) => {
      
       
      return data
    }, (error) => {
      return error
    })
   
  },

  [TYPES.CREATE_DEPOSITS] ({ state }, agent) {
    return api.post('deposit', agent).then(({ data }) => {
       return data
    }, (error) => {
      return error
    })
  },

  [TYPES.CREATE_WITHDRAWAL] ({ state }, agent) {
    return api.post('withdraw', agent).then(({ data }) => {
       return data
    }, (error) => {
      return error
    })
  },

  [TYPES.CREATE_IPLIST] ({ state }, agent) {
    return api.post('user/iplist', agent).then(({ data }) => {
       return data
    }, (error) => {
      return error
    })
  },

  [TYPES.UPDATE_IPLIST] ({ state }, agent) {
    return api.put('user/iplist', agent).then(({ data }) => {
       return data
    }, (error) => {
      return error
    })
  },
  

  [TYPES.FETCH_BETLIMIT] ({ state }) {
    
    if(!state.listbetlimit.length){
     
      api.get('sexymm/betlimit').then(({ data }) => {
        state.listbetlimit = data.data
        /*let tableBetLimit = state.listbetlimit
          _.forEach(tableBetLimit, function(value, key){
            _.set(tableBetLimit[key], "isActive", true)
          })
          
        state.listbetlimit = tableBetLimit
        */
      }, (error) => {
        
      })
    }
  },


// OLD

  [TYPES.FETCH_USERS] ({ state }) {
    api.get('users').then(({ data }) => {
      state.users = data.data
      
    }, (error) => {
      
    })
  },
  [TYPES.FETCH_USER] ({ state }, id) {
    api.get('users?id='+id).then(({ data }) => {
      state.user = data.data
     
    }, (error) => {
     
    })
  },
  [TYPES.UPDATE_USER] ({ state }, id) {
    let b = {
      user_id: id
    }
    api.put('users', b).then(({ data }) => {
      
    }, (error) => {
     
    })
  },
  [TYPES.DELETE_USER] ({ state }, user) {
    api.delete('users', { data: user }).then(({ data }) => {
      state.users.splice(
        state.users.indexOf(user),
        1
      )
    }, (error) => {
      
    })
  },
  [TYPES.FETCH_WITHDRAWALS] ({ state }) {
    api.get('withdrawal/log').then(({ data }) => {
      state.withdrawals = data.data
    }, (error) => {
     
    })
  },
  [TYPES.FETCH_WITHDRAWAL] ({ state }, id) {
    api.get('withdrawal/log?id='+id).then(({ data }) => {
      state.withdrawal = data.data
    }, (error) => {
      
    })
  },
  [TYPES.APPROVE_WITHDRAWAL] ({ state }, withdrawal) {
    let b = {
      withdrawal_id: withdrawal.id
    }
    api.post('payment/withdrawal/verify', b).then(({ data }) => {
      state.withdrawals.splice(
        state.withdrawals.indexOf(withdrawal),
        1
      )
    }, (error) => {
      
    })
  },
  [TYPES.DECLINE_WITHDRAWAL] ({ state }, withdrawal) {
    let b = {
      withdrawal_id: withdrawal.id
    }
    api.post('payment/withdrawal/decline', b).then(({ data }) => {
      state.withdrawals.splice(
        state.withdrawals.indexOf(withdrawal),
        1
      )
    }, (error) => {
     
    })
  },
  [TYPES.FETCH_DEPOSITS] ({ state }) {
    api.get('deposit/log').then(({ data }) => {
      state.deposits = data.data
    }, (error) => {
      
    })
  },
  [TYPES.FETCH_DEPOSIT] ({ state }, id) {
    api.get('deposit/log?id='+id).then(({ data }) => {
      state.deposit = data.data
    }, (error) => {
      
    })
  },
  [TYPES.APPROVE_DEPOSIT] ({ state }, deposit) {
    let b = {
      deposit_id: deposit.id
    }
    api.post('payment/deposit/verify', b).then(({ data }) => {
      state.deposits.splice(
        state.deposits.indexOf(deposit),
        1
      )
    }, (error) => {
     
    })
  },
  [TYPES.DECLINE_DEPOSIT] ({ state }, deposit) {
    let b = {
      deposit_id: deposit.id
    }
    api.post('payment/deposit/decline', b).then(({ data }) => {
      state.deposits.splice(
        state.deposits.indexOf(deposit),
        1
      )
    }, (error) => {
      
    })
  },
  [TYPES.FETCH_VENDORS] ({ state }) {
    api.get('superadmin/vendor').then(({ data }) => {
      state.vendors = data.data
    }, (error) => {
      
    })
  },
  [TYPES.FETCH_TASKS] ({ state }) {
    api.get('task').then(({ data }) => {
      state.tasks = data.data
    }, (error) => {
      
    })
  },

  [TYPES.CREATE_TASK] ({ state }, task) {
    task.user_id = state.user.id

    api.post('task', task).then(({ data }) => {
      state.tasks.push(data.data)
    }, (error) => {
      
    })
  },

  [TYPES.UPDATE_TASK] ({ state }, task) {
    api.patch(`task/${task.id}`, task).then(({ data }) => {
      // n00p
    }, (error) => {
     
    })
  },

  [TYPES.DELETE_TASK] ({ state }, task) {
    api.delete(`task/${task.id}`, task).then(({ data }) => {
      state.tasks.splice(
        state.tasks.indexOf(task),
        1
      )
    }, (error) => {
      
    })
  },

  [TYPES.CREATE_TAB] ({ state }, tab) {
    state.tabs.push(tab)
  },

  [TYPES.DELETE_TAB] ({ state }, tab) {
    state.tabs.splice(
      state.tabs.indexOf(tab),
      1
    )
  },

  [TYPES.CLEAR_COMPLETED_TASKS] ({ state, dispatch }) {
    state.tasks.filter(todo => todo.done).forEach(task => {
      dispatch(TYPES.DELETE_TASK, task)
    })
  }
}
